import type { ITableState } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/tableReducer";

import type { IAnalyzedURL, IURLFilterState } from "./types";

export const DOMAIN_FILTER_I18N_KEY = "llm.url_analysis.filters.domain.title";
export const CHANGE_FILTER_I18N_KEY = "llm.prompts.filters.change.title";

export const FILTER_TRACKING_LABEL_KEYS: Record<string, string> = {
    domainFilter: DOMAIN_FILTER_I18N_KEY,
    changeFilter: CHANGE_FILTER_I18N_KEY,
};

export const PAGE_SIZE = 8;
export const DEFAULT_SORT_COLUMN: keyof IAnalyzedURL = "sourceAuthority";
export const TABLE_ID = "source-urls-table";
export const EXCEL_API_ENDPOINT = "/api/aiTracker/reports/sourceAnalysisReport/UrlAnalysisTable/Excel";

export const INITIAL_TABLE_STATE: ITableState<IURLFilterState, keyof IAnalyzedURL> = {
    currentPage: 1,
    searchTerm: "",
    filterState: {},
    sorting: {
        dataIndex: DEFAULT_SORT_COLUMN,
        sortDirection: "descend",
    },
};
